import React from 'react';
import { StyledProps, StyledTabs } from './styles';

export function UITabs(props: StyledProps) {
  return <StyledTabs {...props} />;
}
